const specs = [
    'Acupuncturist','Allergist (Immunologist)','Audiologist',
    'Cardiologist (Heart Doctor)','Cardiothoracic Surgeon','Chiropractor','Colorectal Surgeon',
    'Dentist','Dermatologist','Dietitian / Nutritionist','Diabetes Specialist',
    'Ear, Nose & Throat Doctor (ENT)','Endocrinologist','Eye Doctor',
    'Gastroenterologist','Geriatrician',
    'Hearing Specialist','Headache Specialists','Hematologist (Blood Specialist)',
    'Infectious Disease Specialist','Infertility Specialist',
    'Midwife','Naturopathic Doctor','Nephrologist (Kidney Specialist)',
    'Neurologist','Neurosurgeon',
    'OB-GYN (Obstetrician-Gynecologist)','Oncologist','Ophthalmologist','Optometrist','Oral Surgeon','Orthodontist','Orthopedic Surgeon (Orthopedist)',
    'Pain Management Specialist','Pediatric Dentist','Pediatrician','Physiatrist (Physical Medicine)','Physical Therapist',
    'Plastic Surgeon','Podiatrist (Foot and Ankle Specialist)','Primary Care Physician (PCP)','Prosthodontist','Psychiatrist',
    'Psychologist','Pulmonologist (Lung Doctor)',
    'Radiologist','Rheumatologist',
    'Sleep Medicine Specialist','Sports Medicine Specialist','Surgeon',
    'Therapist / Counselor',
    'Urgent Care Specialist','Urological Surgeon','Urologist',
    'Vascular Surgeon',
    'Other'
  ];

  export default specs;